import axios from "axios";
import authHeader from '../authheader'

const BOARDMEMBERURL = process.env.REACT_APP_APIURL + "/api/BoardMember";

const getBoardMemberResponses = async () => {
    return axios.get(`${BOARDMEMBERURL}/getboardresponses`, { headers: authHeader() });
}
const getBoardMemberResponse = async (boardMemberResponseId, parentTypeId) => {
    return axios.get(`${BOARDMEMBERURL}/getboardresponse`, { headers: authHeader(), params: { boardMemberResponseId, parentTypeId } });
}
const saveBoardMemberResponse = async (data) => {
    return axios.post(`${BOARDMEMBERURL}/saveboardresponse`, null, { headers: authHeader(), params: { ...data } });
}
const saveBoardMemberEmailSetting = async (optIn, days) => {
    return axios.post(`${BOARDMEMBERURL}/saveboardmemberemailsetting`, null, { headers: authHeader(), params: { optIn, days } });
}
const getBoardMemberEmailSetting = async () => {
    return axios.get(`${BOARDMEMBERURL}/getboardmemberemailsetting`, { headers: authHeader() });
}
const getAssignedBoardMembers = async (parentId, parentTypeId) => {
    return axios.get(`${BOARDMEMBERURL}/getassignedboardmembers`, { headers: authHeader(), params: { parentId, parentTypeId } });
} 
export default {
    getBoardMemberResponses,
    getBoardMemberResponse,
    saveBoardMemberResponse,
    saveBoardMemberEmailSetting,
    getBoardMemberEmailSetting,
    getAssignedBoardMembers
};